import React, { useMemo } from "react";
import Card from "@/components/common/card/Card";
import { Table } from "@/components/common/table/Table";
import CardTestFilter from "../CardTestFilter";
import styles from "./Competences.module.css";
import { useCardFilters } from "../useCardFilter";
import type { ColumnDef } from "@/components/common/table/types.props";
import type { competence } from "@/features/dashboard/types.api";

const getLevelClassName = (level: string) => {
    switch (level?.toLowerCase()) {
        case "alto":
            return styles["level-high"];
        case "medio":
            return styles["level-medium"];
        case "bajo":
            return styles["level-low"];
        default:
            return "";
    }
};

const columns: ColumnDef<competence>[] = [
    {
        accessorKey: "name",
        header: "Competencia",
    },
    {
        accessorKey: "level",
        header: "Nivel",
        cell: (row) => (
            <div className={styles["level-cell"]}>
                <span
                    className={`${styles["level-indicator"]} ${getLevelClassName(row.level)}`}
                />
                {row.level}
            </div>
        ),
    },
    {
        accessorKey: "performance",
        header: "Desempeño",
        cell: (row) => (
            <div className={styles["performance-cell"]}>
                <div className={styles["progress-bar-container"]}>
                    <div
                        className={styles["progress-bar-fill"]}
                        style={{ width: `${row.performance}%` }}
                        title={`${row.performance}%`}
                    />
                </div>
                <span className={styles["performance-percentage"]}>
                    {row.performance}%
                </span>
            </div>
        ),
    },
];

const CompetencesCard: React.FC<{ competences: competence[] }> = ({
    competences,
}) => {
    const { selectedTest, testOptions, filteredData, handleTestChange } =
        useCardFilters(competences);

    const dataForTable = useMemo(() => {
        return filteredData.map((comp) => ({
            ...comp,
            id: `${comp.test}-${comp.name}`,
        }));
    }, [filteredData]);

    const headerActions = (
        <CardTestFilter
            options={testOptions}
            selectedValue={selectedTest}
            onChange={handleTestChange}
        />
    );

    return (
        <Card
            title="Desempeño por competencias"
            icon="🏆"
            headerActions={headerActions}
        >
            <Table columns={columns} data={dataForTable} />
        </Card>
    );
};

export default CompetencesCard;
